import React, { useEffect, useState } from "react";
import {
    Controller
  } from "react-hook-form";
const NumberField = function(arg) {
    const {
        className,
        name,
        value,
        control,
        setValue,
        onCustValueChange,
        ...rest
    } = arg
    const [fieldValue, setFieldValue] = useState('')

    useEffect( () => {
        if (value) {
            setValue(name, value)
            setFieldValue(value)
        } else {
            setValue(name, '')
            setFieldValue('')
        }
        
    },[name, setValue, value])

    const onValueChange = (event, field) => {
        let  value = event.target.value;
        field.onChange(value)
        setFieldValue(value)
        if(typeof onCustValueChange === 'function') {
            onCustValueChange(event)
        }
        
    }

    return <> 
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
            <input
                {...field}
                {...rest}
                className={className}
                value={fieldValue}
                onChange={(e) =>  onValueChange(e, field) } 
            />
            )}
        />
    </>

}
export default React.memo(NumberField);